export default __webpack_public_path__ + "static/media/80s_level_lost.69ee2e4d.mp3";